import React from 'react';
import PropTypes from 'prop-types';
const arr = [{ name: 'test', category: 'carrier' }, { name: 'test1', category: 'operations' }];
const Table = props => (
  <div className="module-table top fix-margin-top">
    <table className="fixed">
      <thead>
        <tr>
          <th className="bd left">
            <a onClick={props.handleSort}>
              {props.language.account.table.name} <i className="fas fa-arrows-alt-v" />
            </a>
          </th>
          <th className="th200 left">
            {props.language.account.table.code}
            <div>
              <i className="fas fa-question-circle" />
              <span>{props.language.account.help.codeGeo}</span>
            </div>
          </th>
          <th className="th100 marg-left-geozone">
            {props.language.account.geozone.featureTextOne}
          </th>
          {props.buttonShow && <th className="th100">{props.language.account.table.setting}</th>}
        </tr>
      </thead>
      <tbody>
        {props.datos.map((item, i) => {
          item.characteristics = [
            { name: 'base', state: true },
            { name: 'principal', state: true },
            { name: 'client', state: false },
            { name: 'onDuty', state: false },
            { name: 'stopped', state: false }
          ];
          return (
            <tr key={`row-${i}`}>
              <td
                data-num={i}
                onClick={props.handleGeozone}
                className={!item.state ? 'bd-gray' : 'bd-green'}
              >
                {item.alias}
              </td>
              <td data-num={i} onClick={props.handleGeozone}>
                {item.code}
              </td>
              <td>
                {item.features.map((item, i) => {
                  if (item.state) {
                    return <p key={i}>{props.language.account.geozone[item.name]}</p>;
                  }
                })}
              </td>
              {props.buttonShow && (
                <td>
                  <div className="button-setting flex justify-center">
                    <div />
                    {item.state ? (
                      <div>
                        <a>
                          <span className="hover-title">
                            {' '}
                            {props.language.account.geozone.modalEdit.editText}
                          </span>{' '}
                          <i
                            data-datos={JSON.stringify(item)}
                            data-close="ok"
                            onClick={props.handleModal}
                            className="fas fa-edit"
                          />{' '}
                        </a>
                        <a>
                          <span className="hover-title">
                            {props.language.account.geozone.modalEdit.deactivateText}
                          </span>{' '}
                          <i
                            data-datos={JSON.stringify(item)}
                            data-close="ok"
                            onClick={props.handleModalDelete}
                            className="fas fa-ban"
                          />{' '}
                        </a>
                      </div>
                    ) : (
                      <div>
                        <a>
                          <span className="hover-title">
                            {props.language.account.geozone.modalEdit.activateText}
                          </span>{' '}
                          <i
                            data-datos={JSON.stringify(item)}
                            data-close="ok"
                            onClick={props.handleModalActive}
                            className="fas fa-smile"
                          />{' '}
                        </a>
                      </div>
                    )}
                  </div>
                </td>
              )}
            </tr>
          );
        })}
      </tbody>
    </table>
    {props.loadingTable && (
      <div className="loading-table">
        <h6>
          <i className="fas fa-spinner fa-spin" />
        </h6>
      </div>
    )}
    {//props.pag >= props.count.pages &&
    props.pag >= 1 && (
      <div className="loading-table">
        <h6>{props.datos.length > 0 ? props.language.account.table.endTime : props.language.account.others.noData}</h6>
      </div>
    )}
  </div>
);

export default Table;



// WEBPACK FOOTER //
// ./source/client/components/account_geozone/table.jsx